export default "__VITE_ASSET__C_usa$0A__"